module.exports = __webpack_public_path__ + "static/media/placeholder_4.6366bde6.jpg";